import { action, computed, observable } from 'mobx';
import { getMessageList, messageRead } from '@/services/messageCenter';
import GlobalStore from '@/store/GlobalStore';
import moment from 'moment';

class MessageCenterStore {
  
  // 消息列表
  @observable messageList = []
  
  @observable pageNumber = 1
  
  @observable pageSize = 100
  
  @observable totalCounts
  
  @observable toast = GlobalStore.toast
 
  // 获取客服信息
  @action.bound async getMessageList () {
    
    const messageList = await getMessageList({pageNumber: this.pageNumber, pageSize: this.pageSize});
    
    if (messageList.code === 10000 ) {
      await messageRead() // 设为已读
      
      this.messageList = messageList.result.message_list.map(r => ({
        title: r.title,
        content: r.content,
        date: moment(r.create_time).format('YYYY-MM-DD HH:mm'),
        status: r.status,
        id: r.id
      }));
      
      this.totalCounts = messageList.result.total_counts;
      return false
    }
    
    this.toast.text(messageList.code === 50003 ? messageList.msg : (messageList.result || messageList.msg))
    
  }
  
}

export default new MessageCenterStore();